import { GenericTableFields, GenericTableField } from './generic-table-field';

//Anagrafica
export class AnagraficaTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Codice Fiscale", "codice_fiscale", "label", "tab-cell-12 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Cognome", "cognome", "label", "tab-cell-20 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Nome", "nome", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Indirizzo", "indirizzo_completo", "label", "tab-cell-20 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Comune", "comune", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Prov.", "prov", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("CAP", "cap", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Aggiornato", "aggiornamento_data_ridotta_view", "label", "tab-cell-8 text-center");
		this.header.push(headerField);
	}
}

//FindContribuenteTableField
export class FindContribuenteTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Codice Fiscale", "codice_fiscale", "label", "tab-cell-12 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Nominativo", "nominativo", "label", "tab-cell-35 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Indirizzo", "indirizzo_completo", "label", "tab-cell-20 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Comune", "comune", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Prov.", "prov", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("CAP", "cap", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Azioni", "actions", "button", "tab-cell-8 text-center");
		this.header.push(headerField);
	}
}

//Statistiche e Rendicontazione
export class StatisticheGeneraleDettaglioTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Nominativo", "nominativo", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Canale", "canale", "label", "tab-cell-6 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Anno", "anno", "label", "tab-cell-3 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Riscosso", "pagato", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Debito", "debito", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Sanzioni", "sanzioni", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Interessi", "interessi", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Sp. Not.", "notificaSpese", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Arr.", "arrotondamento", "label", "tab-cell-4 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Interessi Agg.", "interessiAgg", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Oneri Agg.", "oneriAgg", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Sp. Not. Agg.", "notificaSpeseAgg", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Sp. Esec. Agg.", "esecutiveSpese", "label", "tab-cell-8 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Sp. Giudiz. Agg.", "giudizialiSpese", "label", "tab-cell-7 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Data Accredito", "accreditoData", "label", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Rif.", "rifRata", "label", "tab-cell-3 text-center");
		this.header.push(headerField);
	}
}

// Import File
export class CheckFileImportTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Codice Fiscale", "codice_fiscale", "label", "tab-cell-12 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Cognome", "cognome", "label", "tab-cell-20 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Nome", "nome", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Indirizzo", "indirizzo_completo", "label", "tab-cell-20 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Comune", "comune", "label", "tab-cell-15 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Prov.", "prov", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("CAP", "cap", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Aggiornato", "aggiornamento_data_ridotta_view", "label", "tab-cell-8 text-center");
		this.header.push(headerField);
	}
}

// Sistema
export class OperatoriTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Nome Utente", "username", "label", "tab-cell-16 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Codice Fiscale", "codice_fiscale", "label", "tab-cell-12 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("E-mail", "email", "label", "tab-cell-18 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Nome Completo", "nomeCompleto", "label", "tab-cell-25 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Livello", "livello_id", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Certificato", "certificazione", "slide-toggle", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Data Certificato", "data_certificazione", "label", "tab-cell-9 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Ultimo Accesso", "ultimoAccesso", "label", "tab-cell-9 text-center");
		this.header.push(headerField);
	}
}

export class CittadiniTableField extends GenericTableFields{
	constructor(){
		super();
		let headerField: GenericTableField;
		this.header = [];
		this.footer = [];

		headerField = new GenericTableField();
		headerField.setAllValue("Nome Utente", "username", "label", "tab-cell-16 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Codice Fiscale", "codice_fiscale", "label", "tab-cell-12 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("E-mail", "email", "label", "tab-cell-18 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Nome Completo", "nomeCompleto", "label", "tab-cell-25 text-left");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Livello", "livello_id", "label", "tab-cell-5 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Certificato", "certificazione", "slide-toggle", "tab-cell-6 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Data Certificato", "data_certificazione", "label", "tab-cell-9 text-center");
		this.header.push(headerField);

		headerField = new GenericTableField();
		headerField.setAllValue("Ultimo Accesso", "ultimoAccesso", "label", "tab-cell-9 text-center");
		this.header.push(headerField);
	}
}
